/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library ikmports
import { Component } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { salenotedetail, salenoteadd, itemnotedetail, itemnoteadd } from 'shared/settings/apiconfig';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import Validators from 'shared/validators';

// style imports
import './Notes.scss';

/**
 * this page is used to view or add notes for sale or item
 * 
 * @param props
 * 
 * @returns html code to render note modal box
 * 
**/

export default class Notes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chars_left: 60,
            chars_description: 500,
            form: {
                title: { value: '', error: '', valid: false, validators: [Validators.maxLength(60)] },
                isprivate: { value: false, error: '', valid: true },
                description: { value: '', error: '', valid: false }
            },
            valid: false,
            notes: [],
            modal: false,
            title: '',
            loading: false,
            notesStatus: { show: false, type: '', message: '' },
        }
    }

    componentDidMount() {
        this.getData();
    }

    /* get data for sale or item */
    getData = () => {
        this.setState({
            ...this.state,
            title: this.props.data['title'],
            modal: this.props.modal
        }, () => {
            this.getNoteList();
        });
    }

    /* get list of notes for sale*/
    getNoteList = (message = null) => {
        const noteApi = {
            sale: salenotedetail,
            item: itemnotedetail
        };

        axios.get(getSellerUrl(`${noteApi[this.props['name']]}/${this.props.id}`), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        ...this.state,
                        notes: response.data.data.reverse(),
                        modal: this.props.modal,
                        loading: false
                    });
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    notesStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    }

    /*called when input changed */
    inputChange = (event) => {
        let inputError = '';
        let eventValue = event.target.value;
        if (event.target.name === 'isprivate') {
            eventValue = !this.state.form.isprivate.value;
        }

        if (Object.keys(this.state.form[event.target.name]).includes('validators')) {
            for (let validator of this.state.form[event.target.name].validators) {
                inputError = validator(eventValue);
                if (inputError) break;
            }
        }
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [event.target.name]: {
                    ...this.state.form[event.target.name],
                    value: eventValue,
                    error: inputError,
                    valid: !Boolean(inputError)

                }
            }
        }, () => {
            if (inputError)
                this.setState({
                    ...this.state,
                    valid: false
                });
            else {
                let valid = true;
                for (let control of Object.keys(this.state.form)) {
                    if (!this.state.form[control].valid) {
                        valid = false;
                        break;
                    }
                }
                this.setState({
                    ...this.state,
                    valid: valid
                });
            }
        });

    }

    /* reset form */
    formReset = () => {
        this.setState({
            ...this.state,
            form: {
                title: { value: '', error: '', valid: false, validators: [Validators.maxLength(60)] },
                isprivate: { value: false, error: '', valid: true },
                description: { value: '', error: '', valid: false }
            }
        });
    }

    /* called when submitting form */
    submitNote = () => {
        let data = {};
        this.setState({ loading: true });
        Object.entries(this.state.form).forEach(([key, value]) => data[key] = value['value']);
        if (this.props.name === 'sale')
            data['saleid'] = this.props.id;
        else
            data['itemid'] = this.props.id;

        const noteApi = {
            sale: salenoteadd,
            item: itemnoteadd
        };

        axios.post(getSellerUrl(noteApi[this.props['name']]), JSON.stringify({ data: data }), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        loading: false,
                        notesStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                notesStatus: { show: false, type: '', message: '' }
                            }, () => {
                                this.getNoteList(response.data['status']);
                                this.formReset();
                            });
                        }, 3000)
                    });

                    // toast.success(response.data['status']);
                    // this.props.hideNotes();
                }
                if (this.props.getNotesCount) {
                    this.props.getNotesCount();
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    notesStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
                // toast.error(error.response.data['message']);
                // this.props.hideNotes();
            });

    }

    render() {
        return (
            <Modal size="lg" className="notes" show={this.state.modal} onHide={() => this.setState({ ...this.state })} id="notes-modal">
                <Modal.Header style={{ border: "none" }}>
                    <div>
                        <h4>{this.props.name.charAt(0).toUpperCase() + this.props.name.slice(1)} Note</h4>
                        <h6>{this.state.title}</h6>
                    </div>
                    <Button type="button" onClick={() => this.props.hideNotes()} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                </Modal.Header>
                <Modal.Body style={{ padding: "0 1rem 1rem" }}>
                    {/* { this.state.loading ?
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="default" height="100px" width="100px" />
                        </div> :  */}
                    <div>
                        <div className="notesForm">
                            <Form style={{ marginBottom: "1%" }}>
                                <div className="row">
                                    <div className="col-md-6" style={{ marginBottom: "1%", marginTop: "-1%" }}>
                                        <small className="maxcharnote" style={{ color: '#878787' }}>{this.state.chars_left - this.state.form.title.value.length}/60</small>
                                        <Form.Control name="title" placeholder="Add a note title here" maxLength='60' onChange={(event) => this.inputChange(event)} value={this.state.form.title.value} /></div>
                                    <div className="col-md-4"><Form.Check type="checkbox" name="isprivate" label="Private(viewable by me only)" style={{ marginLeft: "3%" }} onChange={(event) => this.inputChange(event)} checked={this.state.form.isprivate.value} /></div>
                                </div>
                                <div>
                                    <small className="maxcharnote" style={{ color: '#878787' }}>{this.state.chars_description - this.state.form.description.value.length}/500</small>
                                    <Form.Control as="textarea" name="description" onChange={(event) => this.inputChange(event)} maxLength="500" placeholder="Type in the body of your note here..." value={this.state.form.description.value} />
                                </div>
                            </Form>
                            {
                                this.state.notesStatus.show ?
                                    <ToasterMessage type={this.state.notesStatus.type} message={this.state.notesStatus.message} className="alert-handle"></ToasterMessage>
                                    : null
                            }
                            <Button varaiant="secondary" className="save-button" disabled={this.state.loading || this.state.notesStatus.type === 'success'} onClick={() => this.submitNote()}>Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>

                        </div>
                        <div className={this.state.notes.length ? "notelist" : ''} >
                            {this.state.notes.map(note =>
                                <div className="noteData">
                                    <div className="d-flex flex-row flex-wrap justify-content-between">
                                        <h6 className=""><b>{note.title}</b> {note.isprivate ? <i className="fa fa-lock" style={{ color: "#A12142" }}></i> : ''}</h6>
                                        <div>
                                            <div>{note.addedby},</div>
                                            <div>{moment.utc(note.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</div>
                                        </div>
                                    </div>
                                    <div className="notes-body">{note.description}</div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* }     */}
                </Modal.Body>
            </Modal>
        );
    }
}

